  import { RootState } from '../../../store';
import { IWaterSystemsMetrics } from '../../../types';
  
const selectWaterSystemsData = (state: RootState): IWaterSystemsMetrics => 
  state.waterSystemMetrics.data ?? [];
const loading = (state: RootState) => state.waterSystemMetrics.loading;

export const WaterSystemsMetricsSelector = {
  selectWaterSystemsData,
  loading,
};
